import React, { useEffect, useState } from "react";
import "./Speechdevelopment.css";
import { Accordion } from "react-bootstrap";
import { speechDevelopmentTrackingListApi } from "services/speechDevelopmentTracking";
import useFullPageLoader from "common/UseFullPageLoader";
import { IoIosArrowDown } from "react-icons/io";
import { mic, recognize_img } from "assets/images";
import { CustomModal } from "components/modals/ModalBox";
import { dateFormatWithTime } from "utils/dateFormat";

const Speechdevelopment = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});

  const [imageopen, setimageopen] = useState(false);

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await speechDevelopmentTrackingListApi({
        childId: _child,
        limit: 5000,
      });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="Speechdevelopment_parent">
        <div className="speechdevelopment_wraper">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="vaccination_record_left">
                <div className="vaccination_accordion">
                  <div className="left_accordian">
                    <div className="accordian_parent_wrap">
                      <Accordion>
                        {feedingList?.map((item, index) => {
                          return (
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header>
                                <div className="first_accordian_content">
                                  <div className="accordian_text">
                                    <b>{item?.name}</b>
                                    <div className="accordian_down">
                                      <ul>
                                        <li>
                                          <span className="date">
                                            Week {item?.startWeek} -{" "}
                                          </span>
                                          <span className="timing">
                                            Week {item?.endWeek}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Header>

                              <Accordion.Body>
                                <div className="sub_child_wraper">
                                  {
                                    item?._types?.map(type => {
                                      return <div className="accordian_sub_child" onClick={() => {
                                        if (type?.speechDevelopmentTracking?.createdAt) {
                                          setSelected(type?.speechDevelopmentTracking)
                                        }
                                      }}>
                                        <div className="child_headerr">
                                          <h6>{type?.name}</h6>
                                          <img src={mic} alt="" />
                                        </div>
                                        <div className="date_card">
                                          <span className="dateee">{type?.speechDevelopmentTracking?.createdAt ? dateFormatWithTime(type?.speechDevelopmentTracking?.createdAt) : "Not Completed"}</span>
                                        </div>
                                        <div className="child_fotter">
                                          <p>
                                            {type?.speechDevelopmentTracking?.note || ""}
                                          </p>
                                        </div>
                                      </div>
                                    })
                                  }
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {
              selected?._id &&
              <div className="col-sm-12 col-md-6  col-lg-6">
                <div className="vaccination_record_right">
                  <div className="vaccination_heading">
                    <div className="recognize_title">
                      <h5>Recognizes Voices</h5>
                    </div>
                    <div
                      className="recognize_images"
                      onClick={() => setimageopen(true)}
                    >
                      {
                        selected?.speechType === "IMAGE"
                          ?
                          <img
                            src={selected?.speechUrl}
                            alt="images"
                            className="img-fluid"
                          />
                          :
                          selected?.speechType === "AUDIO"
                            ?
                            <audio controls>
                              <source src={selected?.speechUrl} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                            :
                            <video width="640" height="360" controls>
                              <source src={selected?.speechUrl} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                      }
                    </div>
                    <div className="recognize_content">
                      <div className="dates_section">
                        <div className="date_text">
                          <span className="date">
                            {dateFormatWithTime(selected?.createdAt)}
                          </span>
                        </div>

                        <p>
                          {selected?.note || ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

          </div>
        </div>
      </div >

      <CustomModal
        show={imageopen}
        action={() => setimageopen(false)}
        handleClose={() => setimageopen(false)}
      >
        <div className="recognize_img_modal">
          <img src={recognize_img} alt="Recognize_images" className="img-fluid" />
        </div>
      </CustomModal>
    </>
  );
};

export default Speechdevelopment;
